.mainContainer {
  display: flex;
  flex-direction: row;
  width: 100%;
}
